import triggerTracking from '@blueprint/tracking';

const webKey = '8be10ffe-9395-4b37-be4a-5b510a2e7d61';
const APPS_FLYER_BANNER_SCRIPT = `
    !function(t,e,n,s,a,c,i,o,p){t.AppsFlyerSdkObject=a,t.AF=t.AF||function(){
        (t.AF.q=t.AF.q||[]).push([Date.now()].concat(Array.prototype.slice.call(arguments)))},
        t.AF.id=t.AF.id||i,t.AF.plugins={},o=e.createElement(n),p=e.getElementsByTagName(n)[0],o.async=1,
        o.src="https://websdk.appsflyer.com?"+(c.length>0?"st="+c.split(",").sort().join(",")+"&":"")+(i.length>0?"af_id="+i:""),
        p.parentNode.insertBefore(o,p)}(window,document,"script",0,"AF","banners",{banners: {key: "${webKey}"}})
    AF('banners', 'showBanner', { bannerZIndex: 9999 })
`;

export const activateMobileBanner = (isEnabled: boolean, isMobile: boolean) => {
    if (isEnabled && isMobile) {
        try {
            triggerTracking({
                event: 'GAEvent',
                eventCategory: 'mobile_app_banner',
                eventAction: 'banner_shown'
            });

            const script = document.createElement('script');
            script.innerHTML = APPS_FLYER_BANNER_SCRIPT;

            document.head.appendChild(script);
        } catch (e) {
            // This is ok to fail silently
        }
    }

    return null;
};
